import { Container } from '@mui/material';
import React, { useEffect, useState } from 'react';

export default function Header() {
    let [nav, setNavStyle] = useState({
        boxShadow: false,
        background: false,
        blur: false,
        position: false,
        zIndex: false,
    })

    function handleScroll() {
        let scroll = window.scrollY;
        if (scroll > 50) {
            setNavStyle({ boxShadow: true, background: true, blur: true, position: true, zIndex: true, });
        } else {
            setNavStyle({ boxShadow: false, background: false, blur: false, position: false, zIndex: false, });
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div
            style={{
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                zIndex: nav.zIndex ? '2' : '1',
                background: nav.background ? 'rgb(15 7 21 / 60%)' : '#0f0715',
                boxShadow: nav.boxShadow ? 'rgb(128 66 255 / 70%) 0px 0px 30px' : '',
                backdropFilter: nav.blur ? 'blur(5px)' : '',
                transition: 'all 0.3s ease',
            }}
        >
            <Container className='navContainer' maxWidth="lg" sx={{
                height: '100px',
                display: "flex",
                justifyContent: 'space-between',
                '@media (max-width: 768px)': {
                    height: '90px !important',
                }
            }}>
                <a href='/'>
                    <img loading='lazy' src={require('../image/Logo.png')} alt='Logo' style={{
                        width: '100px',
                        height: '100px',
                        alignSelf: "center",
                    }} />
                </a>
                <button className='NavBtn' onClick={() => {
                    window.open('https://wa.me/201011448045', '_blank');
                }}>Contact</button>
            </Container>
        </div>
    );
}